import React, { forwardRef, Fragment } from 'react';
import { createPortal } from 'react-dom';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import styles from './assets/styles.scss';
import Backdrop from '../Backdrop/Backdrop';

import IconCloseSquare from './assets/close-square.svg?inline';

const cx = classNames.bind(styles);

const SideSlider = forwardRef(({
  isOpen, onClose, children, className,
}, ref) => (
  <Fragment>
    <Backdrop visible={isOpen} onClick={onClose} />
    {createPortal(
      <div className={cx('side-slider', { open: isOpen }, className)} ref={ref}>
        <button className={cx('close-button')} type="button" onClick={onClose}>
          <IconCloseSquare />
        </button>
        {children}
      </div>,
      document.getElementsByTagName('body')[0]
    )}
  </Fragment>
));
export default SideSlider;

SideSlider.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  children: PropTypes.arrayOf(PropTypes.element).isRequired,
  className: PropTypes.string,
};
SideSlider.defaultProps = {
  className: null,
};
